import React, { useEffect, useState } from "react";
import { Button, Flex, FormControl, FormLabel, HStack, NumberInput, NumberInputField, Select, Text, VStack } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import { ContentArea } from "./ContentArea";
import { useFocus } from "./useFocus";
import { v4 as uuidv4 } from "uuid";
import { SelectControl } from "./SelectControl";
function isStack(element) {
    return element.type === "stack";
}
export const StackContentElement = (props) => {
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    useEffect(() => {
        if (!isStack(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "stack", data: {
                    direction: "row",
                    spacing: 2,
                    justify: "flex-start",
                    align: "flex-start",
                    children: [
                        {
                            id: uuidv4(),
                            type: "stackItem",
                            data: null
                        }
                    ]
                } });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isStack(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    const directions = typeof props.contentElement.data.direction === "string" ? [props.contentElement.data.direction] : props.contentElement.data.direction;
    return (React.createElement(Flex, Object.assign({ ref: setRef, flexDirection: props.contentElement.data.direction, gap: props.contentElement.data.spacing, justifyContent: props.contentElement.data.justify, alignItems: props.contentElement.data.align, pb: "50px" }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, position: "left-start", label: "Stack", attachTo: ref },
                React.createElement(VStack, { w: "100%" },
                    React.createElement(FormControl, null,
                        React.createElement(FormLabel, null, "Direction"),
                        directions.map((direction, i) => (React.createElement(React.Fragment, null,
                            React.createElement(Text, { fontSize: "xs", color: "gray.500" },
                                "Breakpoint ",
                                i),
                            React.createElement(SelectControl, { options: [
                                    {
                                        value: "row",
                                        label: "Row"
                                    },
                                    {
                                        value: "column",
                                        label: "Column"
                                    },
                                    {
                                        value: "row-reverse",
                                        label: "Row Reverse"
                                    },
                                    {
                                        value: "column-reverse",
                                        label: "Column Reverse"
                                    }
                                ], value: direction, onChange: (newDirection) => {
                                    const copy = directions;
                                    // @ts-ignore
                                    copy[i] = newDirection.value;
                                    props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { direction: copy }) }));
                                } })))),
                        React.createElement(HStack, { py: 2 },
                            React.createElement(Button, { variant: "outline", onClick: () => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { direction: [...directions, directions[directions.length - 1]] }) })) }, "Add breakpoint"),
                            React.createElement(Button, { variant: "outline", onClick: () => {
                                    if (directions.length <= 1) {
                                        return;
                                    }
                                    props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { direction: directions.slice(0, -1) }) }));
                                } }, "Remove breakpoint"))),
                    React.createElement(FormControl, null,
                        React.createElement(FormLabel, null, "Justify"),
                        React.createElement(Select, { value: props.contentElement.data.justify, onChange: event => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { justify: event.target.value }) })) },
                            React.createElement("option", { value: "flex-start" }, "Start"),
                            React.createElement("option", { value: "center" }, "Center"),
                            React.createElement("option", { value: "flex-end" }, "End"),
                            React.createElement("option", { value: "stretch" }, "Stretch"),
                            React.createElement("option", { value: "space-evenly" }, "Space Evenly"))),
                    React.createElement(FormControl, null,
                        React.createElement(FormLabel, null, "Align"),
                        React.createElement(Select, { value: props.contentElement.data.align, onChange: event => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { align: event.target.value }) })) },
                            React.createElement("option", { value: "flex-start" }, "Start"),
                            React.createElement("option", { value: "center" }, "Center"),
                            React.createElement("option", { value: "flex-end" }, "End"),
                            React.createElement("option", { value: "stretch" }, "Stretch"))),
                    React.createElement(FormControl, null,
                        React.createElement(FormLabel, null, "Spacing"),
                        React.createElement(NumberInput, { value: props.contentElement.data.spacing, onChange: (asString, asNumber) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { spacing: asNumber }) })) },
                            React.createElement(NumberInputField, null))))),
        React.createElement(ContentArea, { attachControlsTo: ref, showAdd: isActive, contentElements: props.contentElement.data.children, onChange: elements => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { children: elements }) })), allowedTypes: ["stackItem"] })));
};
